import { Button, Dialog } from "@/components/DesignSystem";
import { SubwalletInputSelector } from "@/components/shared/Subwallet/SubwalletInputSelector";
import { ApiPromotion, ApiRetailer } from '@api/interfaces';
import React, { useState } from "react";

type EditSubwalletModalBaseProps = {
  currentSubwalletId: string | null,
  onClose: () => void,
  onSave: (subwalletId: string) => void,
};

type EditSubwalletModalPromotionProps = EditSubwalletModalBaseProps & {
  promotion: ApiPromotion,
  retailer?: never,
};

type EditSubwalletModalRetailerProps = EditSubwalletModalBaseProps & {
  promotion?: never,
  retailer: ApiRetailer,
};

type EditSubwalletModalProps =
  | EditSubwalletModalPromotionProps
  | EditSubwalletModalRetailerProps;

export const EditSubwalletModal = ({
  currentSubwalletId,
  onClose,
  onSave,
  promotion,
  retailer,
} : EditSubwalletModalProps) => {
  const [subwalletId, setSubwalletId] = useState<string | null>(currentSubwalletId);

  return (
    <Dialog
      acceptButton={() => (
        <Button
          disabled={!subwalletId}
          onClick={() => {
            if (!subwalletId) {
              return;
            }
            onSave(subwalletId);
          }}
          testID='subwallet-save-button'
          variant='contained'
        >
          Save
        </Button>
      )}
      cancelButton={(props) => (
        <Button
          onClick={onClose}
          {...props}
          color='inherit'
          testID="subwallet-cancel-button"
        >
          Cancel
        </Button>
      )}
      onClose={onClose}
      open
      showCloseButton={false}
      testID="subwallet-dialog"
      title={promotion ? promotion.name : retailer.name}
    >
       {promotion ? (
         <SubwalletInputSelector
           onChange={setSubwalletId}
           promotion={promotion}
           selectedSubwalletId={subwalletId}
         />
       ) : (
         <SubwalletInputSelector
           onChange={setSubwalletId}
           retailer={retailer}
           selectedSubwalletId={subwalletId}
         />
       )}
    </Dialog>
  );
};
